<H1>Links</H1>
<app-http-loader [componentId]="componentId">
  @if(groupedLinks$ | async; as groupedLinks) {
    @for(linkType of (groupedLinks | keyvalue); track linkType) {
    <div>
      <h2>{{ linkType.key }}</h2>
      @for(link of linkType.value; track link) {
        <div>
          <mat-card (click)="navigateTo(link)" style="cursor: pointer">
            <mat-card-header>
              <mat-card-title>
                <h3>{{ link.title }}</h3>
              </mat-card-title>
              <div class="link-type">{{ linkType.key }}</div>
            </mat-card-header>
            <mat-card-content>
              <img
                src="{{ linkImagesUrl }}{{ link.image.name }}"
                alt="{{ link.title }}"
                class="link-image"
              />
              <div class="link-body" [innerHTML]="link.body"></div>
            </mat-card-content>
            <mat-card-actions>
              <button
                class="button-standard-action icon-button"
                mat-raised-button
                (click)="navigateTo(link)"
              >
                Naar website <mat-icon>double_arrow</mat-icon>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      }
    </div>
    }
  }
</app-http-loader>
